import Gator from "gator";
import Headroom from "headroom.js";

let header;

_gg.domReady(() => {
    header = document.querySelector(".page-header");

    if (header && header.classList.contains("headroom")) {
        let headr = new Headroom(header, {
            //tolerance: 0,
            offset: 100
        });
        headr.init();
    }
});

Gator(_gg.html).on("click", ".header-opening-times", function() {
    document.body.classList.toggle("-header-shops-open");
    this.blur();
});

Gator(_gg.html).on("click", ".hamburger-icon", function() {
    document.body.classList.toggle("-menuopen");
    this.blur();
});

Gator(_gg.html).on("click", ".nav-element.-level1.-hassub > a", event => {
    event.stopPropagation();
});

Gator(_gg.html).on("click", ".nav-element.-level1.-hassub", function() {
    this.classList.toggle("-listopen");
});
